<div
	class="ada-container ada-flex-column ada-full-height ada-col-1 ada-colspan-1"
	style="position: relative"
>
	@if (aida.isSearchOpen()) {
		<ada-search-navigation
			[numberOfMatches]="chatService.searchResults().length"
			[(index)]="chatService.searchIndex"
			(close)="toggleSearch()"
			(valueChange)="search($event)"
		/>
	}
	<ada-chat
		inputPlaceholder="Chat with {{ aida.displayName() }}"
		[activeIndex]="chatService.activeMessageIndex()"
		[characterLimit]="characterLimit()"
		[isResponding]="isResponding()"
		[isSendAllowed]="allowSend()"
		[messages]="chatService.messages()"
		[queryController]="queryController"
		[responseController]="responseController"
		[style.flex-grow]="'1'"
		[suggestions]="chatService.suggestedPrompts()"
		[warningThreshold]="warningThreshold()"
		(messageSent)="submit($event)"
	>
		@if (forkService.activeFork()) {
			<ng-template #ChatFooter>
				<div ada-llm-chat-footer></div>
			</ng-template>
		}
	</ada-chat>
	@if (chatService.errorMessages().length) {
		<ada-alert-panel
			isDismissable="true"
			opacity="0.6"
			style="position: absolute"
			title="Aida Errors"
			[messages]="chatService.errorMessages()"
			[type]="errorAlertType"
			(dismiss)="aida.setConversation()"
		/>
	}
</div>
